import { DrivetrainType } from 'graphql/generated';

export const DrivetrainTypeValues: { [key in DrivetrainType]: string } = {
  fwd: 'FWD',
  rwd: 'RWD',
  awd: 'AWD',
  n4wd: '4WD',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromDrivetrainTypeValue = (value: string) => {
  switch (value) {
    case 'FWD':
      return DrivetrainType.fwd;
    case 'RWD':
      return DrivetrainType.rwd;
    case 'AWD':
      return DrivetrainType.awd;
    case '4WD':
      return DrivetrainType.n4wd;
    case 'Other':
      return DrivetrainType.other;
    case 'Unknown':
      return DrivetrainType.unknown;
    default:
      throw new Error(`invalid DrivetrainType value: ${value}`);
  }
};
